import React from 'react'

const RegionalMemberView = (props) => {
    return (
        <div className='member-card-container'>
            {props.children}
        </div>
    )
}

export default RegionalMemberView